import { React, Fragment } from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './home.jsx';
import PageNotFound from './404.jsx';

export default function Links() {
    return (
        <Fragment>
            <Routes>
                <Route index element={<Home />} />  
                <Route path="*" element={<PageNotFound />} />   
            </Routes>
        </Fragment>
    );
}
